import getAccounts from './getAccounts';
import getSocialBenchmarkingAccountGroups from './getSocialBenchmarkingAccountGroups';
import updateFavorites from './updateFavorites';
import getLeaguesAndFavorites from './getLeaguesAndFavorites';
import sendNotifications from '../notifications/send';

import combineActions from '../../utils/combineActions';

export default combineActions({
    getAccounts,
    getSocialBenchmarkingAccountGroups,
    updateFavorites,
    getLeaguesAndFavorites,
    sendNotifications,
});
